import { TaskDataRow } from "./taskDataRow";
var TaskDataRowEdit = /** @class */ (function () {
    function TaskDataRowEdit(obj) {
        this.item = null;
        if (obj && obj.item) {
            this.item = new TaskDataRow(obj.item);
        }
        this.userCode = obj && obj.userCode || "";
        this.userName = obj && obj.userName || "";
        this.userPicture = obj && obj.userPicture || "";
    }
    return TaskDataRowEdit;
}());
export { TaskDataRowEdit };
